import { Button } from 'react-bootstrap';
import CLM from '../../images/CLMLogo.png';
import ITS from '../../images/treatmentTrackerIcon2.webp';
import SCIRP from '../../images/CWFRTF_logo_badge_clr.png';
import cwilogo from '../../images/cwilogo.jpeg';

const CollectionCard = (props) => {
  const { title, handleView, type, info } = props;

  return (
    <div className="page_layout_1">
      <div className="img_background" aria-hidden="true">
        {type === 'ITS' ? (
          <img className="img_its" src={ITS} alt="Its logo" />
        ) : type === 'CLM' ? (
          <img className="img_clm" src={CLM} alt="Clm logo" />
        ) : type === 'SCIRP' ? (
          <img className="img_scirp" src={SCIRP} alt="SCIRP logo" />
        ) : (
          <img
            className="img_boundary"
            style={{ height: '130px' }}
            src={cwilogo}
            alt="boundary image"
          />
        )}
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',

          marginBottom: '1rem',
          minHeight: '108px',
        }}
      >
        <p
          style={{
            fontSize: '24px',
            fontWeight: 'bold',
            marginBottom: '0',
            color: '#2C3E37',
          }}
        >
          {title}
        </p>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            minHeight: '109px',
          }}
        >
          <>{info}</>
          {handleView && (
            <div style={{ marginBottom: '2px' }}>
              <Button
                className="btn_primary"
                onClick={handleView}
                aria-label={`Explore ${title}`}
              >
                Explore
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default CollectionCard;
